import React, { PropsWithChildren } from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import CheckBox from '@Components/Selectors/Checkbox'
import { CheckboxFormFieldProps } from '@App/forms/common/checkbox-form-field'

const CheckboxForm = (props: PropsWithChildren<CheckboxFormFieldProps>) => {
    const { control } = useFormContext()
    const {
        name,
        mainColor = true,
        size,
        label,
        checked,
        labelInfo,
        readonly,
        children,
        registerOptions,
        rounded,
    } = props

    return (
        <Controller
            name={name}
            control={control}
            rules={registerOptions}
            defaultValue={checked}
            render={({ field: { value, onChange } }) => (
                <CheckBox
                    mainColor={mainColor}
                    onClick={onChange}
                    size={size}
                    labelInfo={labelInfo}
                    text={label}
                    checked={!!value}
                    disabled={!!registerOptions && registerOptions.disabled}
                    id={name}
                    readonly={readonly}
                    rounded={rounded}
                >
                    {children}
                </CheckBox>
            )}
        />
    )
}

export default CheckboxForm
